(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  function loadProductRecommendations(sectionEl) {
    if (!sectionEl) return;

    const url = sectionEl.dataset.url;
    if (!url) return;

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to load product recommendations');
        }

        return response.text();
      })
      .then(responseText => {
        if (!sectionEl.isConnected) return;

        const container = document.createElement('div');
        container.innerHTML = responseText;

        const recommendations = container.querySelector(
          '.product-recommendations'
        );

        if (recommendations && recommendations.innerHTML.trim()) {
          sectionEl.innerHTML = recommendations.innerHTML;

          if (
            window.theme &&
            typeof window.theme.initProductTitleAlignmentWatcher === 'function'
          ) {
            window.theme.initProductTitleAlignmentWatcher(
              sectionEl,
              '.product-grid'
            );
          }
        }
      })
      .catch(error => {
        console.error('Product recommendations error:', error);
      });
  }

  function initProductRecommendations(scope = document) {
    const sections = scope.querySelectorAll(
      '.product-recommendations'
    );

    sections.forEach(sectionEl => {
      loadProductRecommendations(sectionEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initProductRecommendations();
    });
  } else {
    initProductRecommendations();
  }

  document.addEventListener('shopify:section:load', event => {
    initProductRecommendations(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
